// The API exchanges tournament dates as DD-MM-YYYY, while <input type="date">
// speaks YYYY-MM-DD. Convert at the edges rather than in each form.

export const apiDateToInput = (value) => {
  if (!value) return "";
  const [day, month, year] = value.split("-");
  return year ? `${year}-${month}-${day}` : "";
};

export const inputDateToApi = (value) => {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  return day ? `${day}-${month}-${year}` : "";
};

export const formatDate = (value) => {
  const iso = apiDateToInput(value) || value;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
